import React from 'react'
import { logEvent } from '../../Utils'
import { Con } from '../Layout/Containers/ConStyles'
import { BlackBtnLink } from './styles'

type BlackButtonLinkProps = {
  href: string
  center?: boolean
  analytics?: { event: string; params?: any }
}

export const BlackButtonLink: React.FC<
  React.PropsWithChildren<BlackButtonLinkProps>
> = ({ href, center, analytics, children }) => {
  const log = () => {
    analytics && logEvent(analytics.event, analytics.params)
  }

  if (center) {
    return (
      <Con noMargin noPadding justify="center">
        <BlackBtnLink href={href} aria-label={`${analytics?.params?.title} - ${analytics?.params?.btn_text}`}>
          <div onClick={() => log()}>{children}</div>
        </BlackBtnLink>
      </Con>
    )
  } else {
    return (
      <BlackBtnLink href={href} aria-label={`${analytics?.event} - ${analytics?.params?.btn_text}`}>
        <div onClick={() => log()}>{children}</div>
      </BlackBtnLink>
    )
  }
}
